import FormError from './FormError';
import TitledPanel from './TitledPanel';
import DateFnsUtils from '@date-io/date-fns';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import { Typography } from '@material-ui/core';

class GetDatetimeValueDialog extends React.Component {

    state = {
        open: false,
        existing: false,
        date: Date.now(),
        existingValues: [],
        invalid: false,
        error: false
    };

    // Need to check if an incoming revision causes a duplicate
    static getDerivedStateFromProps(props, state) {
        if (props.existingValues && props.existingValues.length > 0) {
            if (props.existingValues.length === state.existingValues.length) {
                const hasChanged = props.existingValues.some(ev => !state.existingValues.includes(ev));
                if (!hasChanged) return null;
            }
            return { needsValidating: true, existingValues: props.existingValues };
        }
        return null;
    }

    componentDidUpdate() {
        if (this.state.needsValidating) this.checkValidity();
    }

    handleClickOpen = () => this.setState({ open: true }, this.checkValidity);

    addLiteral = () => {
        this.setState({ open: false });
        const date = new Date(this.state.date);
        let isoDate = date.toISOString();
        this.props.onSetDate(isoDate, "http://www.w3.org/2001/XMLSchema#dateTime");
        this.setState({ date: Date.now() });
    };

    exitAddLiteral = () => this.setState({ open: false, date: Date.now() });

    checkValidity() {
        let existing = false;
        if (!isNaN(Date.parse(this.state.date))) {
            const date = new Date(this.state.date);
            let isoDate = date.toISOString();
            const isoDate1 = isoDate.substring(0, 19) + "Z";
            const isoDate2 = isoDate.substring(0, 19) + ".000Z";
            // Don't allow to match existing values
            if (this.props.existingValues.includes(isoDate1) || this.props.existingValues.includes(isoDate2)) existing = true;
            this.setState({ existing, invalid: false, needsValidating: false });
        }
        else {
            this.setState({ invalid: true, needsValidating: false });
        }
    }

    handleChange = (date) => this.setState({ date, invalid: true }, this.checkValidity);

    render() {

        const { date, existing, invalid } = this.state;
        const { classes, icon } = this.props;

        return (
            <React.Fragment>
                <AddButton icon={icon} dataTest="add-datetime" title="Add a date/time" onClick={this.handleClickOpen} />
                <Dialog
                    className={classes.dialog}
                    open={this.state.open}
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    onClose={this.exitAddLiteral}
                    aria-labelledby="createdatetime-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createdatetime-dialog-title">Pick Date and Time</DialogTitle>
                    <DialogContent>
                        <Typography paragraph variant="body2">Select the time in your local time.</Typography>
                        <Typography paragraph variant="body2">When displayed the time will be displayed in UTC format. This will ensure that everybody sees the same value.</Typography>
                        <TitledPanel title="Date/Time">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    data-test="datetime-picker"
                                    className={classes.datepicker}
                                    variant="inline"
                                    format="yyyy/MM/dd HH:mm"
                                    margin="dense"
                                    id="date-picker-inline"
                                    inputVariant="outlined"
                                    value={date}
                                    onChange={this.handleChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Select date and time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            {existing && !invalid && <FormError>This value already exists.</FormError>}
                        </TitledPanel>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddLiteral} />
                        <PrimaryButton disabled={existing || invalid} onClick={this.addLiteral}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

GetDatetimeValueDialog.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.object,
    existingValues: PropTypes.array,
    onSetDate: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(GetDatetimeValueDialog);
